import { axiosLasta } from 'config';
import { buildResponseUnauthorizedErrorHandler } from 'utils/axiosHelper/axiosErrorHandlerHelper';

export const fetchAuthorizedOrganizationListByLocation = async (locationId) => {
    const response = await axiosLasta(`/client/access-organization/location/${locationId}`, {
        handleResponseError: buildResponseUnauthorizedErrorHandler("You don't have permission to access Authorized Organizations."),
    });
    return response?.data;
};

export const fetchAccessOrganizationByLocIdAndOrgId = async ({ organizationId, locationId }) => {
    const response = await axiosLasta(`/client/access-organization/authorized-organization/${organizationId}/location/${locationId}`, {
        handleResponseError: buildResponseUnauthorizedErrorHandler("You don't have permission to access Authorized Organizations."),
    });
    return response?.data;
};

export const searchOrganizationsFromLocationByName = async ({ locationId, name }) => {
    const url = `/client/organization/location-organization/search`;
    const response = await axiosLasta(url, {
        params: {
            locationId,
            name,
            limit: 100,
        },
        cache: {
            enabled: true,
            key: `client/organization/location-organization/search?locationId=${locationId}&name=${name}&limit=100`,
        },
    });
    return response?.data;
};
